<template>
  <div class="flex">
    <el-table
      :data="listData.results"
      style="width: 100%"
      v-loading="loadingVisit"
    >
      <el-table-column prop="visitDateStr" align="center" label="拜访时间">
      </el-table-column>
      <el-table-column
        prop="visitTypeName"
        align="center"
        width="88"
        label="拜访方式"
      >
      </el-table-column>
      <el-table-column
        prop="visitAim"
        align="center"
        show-overflow-tooltip
        label="拜访事宜"
      >
      </el-table-column>
      <el-table-column
        prop="isFinishedStr"
        align="center"
        width="88"
        label="是否完成"
      >
      </el-table-column>
      <el-table-column
        prop="visitNote"
        align="center"
        show-overflow-tooltip
        label="拜访结果"
      >
      </el-table-column>
      <el-table-column
        prop="salesmanName"
        align="center"
        width="88"
        label="业务员"
      >
      </el-table-column>
      <el-table-column
        prop="teamName"
        align="center"
        show-overflow-tooltip
        label="团队"
      >
      </el-table-column>
    </el-table>
    <div class="pageination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNumber"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next"
        :total="listData.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    isCurrentTab: Boolean,
    id: String,
    // key 组件更新标识
    updatekey: Number,
  },
  data() {
    return {
      page: {
        pageNumber: 1,
        pageSize: 10,
      },
      loadingVisit: false,
    };
  },
  computed: {
    ...mapGetters({
      listData: 'clue/clueVisit',
    }),
  },
  watch: {
    isCurrentTab(val) {
      if (val) this.handleGetVisitData();
    },
    updatekey(val) {
      if (val === 0) return;
      this.page.pageNumber = 1;
      this.handleGetVisitData();
    },
  },
  methods: {
    ...mapActions({
      getClueVisit: 'clue/getClueVisit',
    }),
    handleCurrentChange(val) {
      this.page.pageNumber = val;
      this.handleGetVisitData();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNumber = 1;
      this.handleGetVisitData();
    },
    handleGetVisitData() {
      this.loadingVisit = true;
      this.getClueVisit({
        cluesId: this.id,
        ...this.page,
      }).finally(() => {
        this.loadingVisit = false;
      });
    },
  },
};
</script>

<style>
/* .el-cascader {
  width: 100%;
} */
</style>
